import { render, staticRenderFns } from "./KnowledgeIndex.vue?vue&type=template&id=0bbf999c&scoped=true&"
import script from "./KnowledgeIndex.vue?vue&type=script&lang=js&"
export * from "./KnowledgeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf999c",
  null
  
)

export default component.exports